module.exports = __webpack_public_path__ + "img/zuijia_36.f94b9f3c.png";